export const formatTimeZoneLabel = (timeZone: string) => {
  try {
    const date = new Date();
    const formatter = new Intl.DateTimeFormat('en-GB', {
      timeZone,
      timeZoneName: 'shortOffset',
      hour12: false
    });

    const timeZoneParts = formatter.formatToParts(date);
    const timeZoneOffset =
      timeZoneParts.find((part) => part.type === 'timeZoneName')?.value || '';

    // Handle special cases and ensure consistent GMT format
    let gmtOffset = timeZoneOffset;
    if (timeZoneOffset) {
      // Add GMT prefix if missing
      if (!timeZoneOffset.startsWith('GMT')) {
        gmtOffset = 'GMT' + timeZoneOffset;
      }

      // Capture the sign, hours and optional minutes. Minutes appear either
      // colon-separated ("GMT+5:30") or as a contiguous four-digit offset
      // ("+0530"), so half-hour zones like IST (+5:30) are preserved.
      const match = gmtOffset.match(/GMT\s*([+-])?(\d{1,2})(?::?(\d{2}))?/);
      if (match) {
        const sign = match[1] || '+';
        const hours = parseInt(match[2], 10).toString();
        const minutes = match[3] || '00';

        gmtOffset = `GMT ${sign}${hours}:${minutes}`;
      }

      // Handle GMT+0 or GMT case
      if (
        gmtOffset === 'GMT' ||
        gmtOffset === 'GMT+0' ||
        gmtOffset === 'GMT-0'
      ) {
        gmtOffset = 'GMT +0:00';
      }
    }

    return `${timeZone} (${gmtOffset})`;
  } catch (error) {
    return timeZone;
  }
};
